exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/structure/admin-site-menu/admin-site-menu.component.css
// module id = ../../../../../src/app/components/structure/admin-site-menu/admin-site-menu.component.css
// module chunks = main